import Vue from 'vue';
import VueRouter from 'vue-router';
import index from '@/views/index/index.vue';
import BgcOne from '@/views/index/bgcOne.vue';
import BgcDataNow from '@/views/index/bgcDataNow.vue';
import OrgOne from '@/views/index/orgOne.vue';
import home from '@/views/home.vue';
import map from '@/views/map.vue';
import login from '@/views/login/index.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        component: index,
        name: 'Index'
    },
    {
        path: '/BgcOne',
        component: BgcOne,
        name: 'BgcOne'
    },
    {
        path: '/BgcDataNow',
        component: BgcDataNow,
        name: 'BgcDataNow'
    },
    {
        path: '/OrgOne',
        component: OrgOne,
        name: 'OrgOne'
    },
    {
        path: '/home',
        component: home,
        name: 'Home'
    },
    {
        path: '/map',
        component: map,
        name: 'Map'
    },
    {
        path: '/login',
        component: login,
        name: 'Login'
    },

];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});


// 添加路由前置守卫
router.beforeEach((to, from, next) => {
    // 判断目标路由是否为登录页
    if (to.path === '/login') {
        next();
        return;
    }

    // 获取token（根据实际存储方式调整）
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');

    // 如果没有token，跳转到登录页
    if (!token) {
        next('/login');
    } else {
        // 有token则继续导航
        next();
    }
});

export default router;
